<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<lowgile-table
					#datatable_68
					[serverDataStore]="Toolbox.Db"
					[trackBy]="trackByAutomatic"
					[entity]="Toolbox.GoalSetting.ForList"
					[columns]="_DataTableBlock_columns_68(screen)"
					[showSettings]="false"
					[userDefinedConfiguration]="undefined"
					[usePaging]="true"
					[pageSize]="20"
					[pageSizeOptions]="[10, 20, 50]"
					[useGlobalFilter]="false"
					[debouncingDelay]="250"
					[stickyHeader]="true"
					[additionalFindOptions]="_DataTableBlock_additionalFindOptions_68({ app, screen, $pathSegments, $disabled })"
					[additionalHeaderRows]="[]"
					[additionalFooterRows]="[]"
					[allClasses]="$Modules"
					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
					[surroundingScope]="$scope"
					#$table_68="lowgileTable"
				>
					<ng-container
						[lowgile-column]="'id'"
						[columnValueFn]="_DataTableColumnBlock_sortAndFilter_79_79({ app, screen, $pathSegments, $disabled })"
					>
						<th mat-header-cell *matHeaderCellDef [mat-sort-header]="'id'">
							<span
								[innerHtml]="'ID' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let gs; let gsIndex = index"
							[attr.data-label]="'ID'"
						>
							<ng-container *lowgileScope="gs; as: 'gs'; let $scope">
								<ng-container *lowgileScope="gsIndex; as: 'gsIndex'; let $scope">
									<a
										[href]="`GoalSetting${screen.linkToScreen}?id=${gs.id}` | safeUrl"
										target="_self"
									>
										<span
											[innerHtml]="gs.id | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</a>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('id') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container
						[lowgile-column]="'cycle.startDate'"
						[columnValueFn]="_DataTableColumnBlock_sortAndFilter_71_71({ app, screen, $pathSegments, $disabled })"
					>
						<th mat-header-cell *matHeaderCellDef [mat-sort-header]="'cycle.startDate'">
							<span
								[innerHtml]="'Appraisal cycle' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let gs; let gsIndex = index"
							[attr.data-label]="'Appraisal cycle'"
						>
							<ng-container *lowgileScope="gs; as: 'gs'; let $scope">
								<ng-container *lowgileScope="gsIndex; as: 'gsIndex'; let $scope">
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_71({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('cycle.startDate') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef>
							<div style="display: flex">
								<select
									#colFilterInput71
									[attr.data-filter-for-column]="'cycle.startDate'"
									style="flex-grow: 1"
								>
									<option value=""></option>
									<option
										*ngFor="let $option of screen.allCycles"
										[value]="$option.id"
									>
										{{ $option.getDateRange() }}
									</option>
								</select>
								<button
									[disabled]="!colFilterInput71.value"
									matSuffix
									mat-icon-button
									mat-small-icon-button
									aria-label="Clear"
									(click)="colFilterInput71.value = ''; $dispatchInputEvent(colFilterInput71)"
								>
									<mat-icon *ngIf="colFilterInput71.value">close</mat-icon>
								</button>
							</div>
						</th>
					</ng-container>

					<ng-container
						[lowgile-column]="'employee.name'"
						[columnValueFn]="_DataTableColumnBlock_sortAndFilter_70_70({ app, screen, $pathSegments, $disabled })"
					>
						<th mat-header-cell *matHeaderCellDef [mat-sort-header]="'employee.name'">
							<span
								[innerHtml]="'Employee' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let gs; let gsIndex = index"
							[attr.data-label]="'Employee'"
						>
							<ng-container *lowgileScope="gs; as: 'gs'; let $scope">
								<ng-container *lowgileScope="gsIndex; as: 'gsIndex'; let $scope">
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_70({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('employee.name') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef>
							<div style="display: flex">
								<input
									#colFilterInput70
									[attr.data-filter-for-column]="'employee.name'"
									style="flex-grow: 1"
								/>
								<button
									[disabled]="!colFilterInput70.value"
									matSuffix
									mat-icon-button
									mat-small-icon-button
									aria-label="Clear"
									(click)="colFilterInput70.value = ''; $dispatchInputEvent(colFilterInput70)"
								>
									<mat-icon *ngIf="colFilterInput70.value">close</mat-icon>
								</button>
							</div>
						</th>
					</ng-container>

					<ng-container
						[lowgile-column]="'manager.name'"
						[columnValueFn]="_DataTableColumnBlock_sortAndFilter_72_72({ app, screen, $pathSegments, $disabled })"
					>
						<th mat-header-cell *matHeaderCellDef [mat-sort-header]="'manager.name'">
							<span
								[innerHtml]="'Manager' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let gs; let gsIndex = index"
							[attr.data-label]="'Manager'"
						>
							<ng-container *lowgileScope="gs; as: 'gs'; let $scope">
								<ng-container *lowgileScope="gsIndex; as: 'gsIndex'; let $scope">
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_72({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('manager.name') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef>
							<div style="display: flex">
								<input
									#colFilterInput72
									[attr.data-filter-for-column]="'manager.name'"
									style="flex-grow: 1"
								/>
								<button
									[disabled]="!colFilterInput72.value"
									matSuffix
									mat-icon-button
									mat-small-icon-button
									aria-label="Clear"
									(click)="colFilterInput72.value = ''; $dispatchInputEvent(colFilterInput72)"
								>
									<mat-icon *ngIf="colFilterInput72.value">close</mat-icon>
								</button>
							</div>
						</th>
					</ng-container>

					<ng-container
						[lowgile-column]="'status$id'"
						[columnValueFn]="_DataTableColumnBlock_sortAndFilter_69_69({ app, screen, $pathSegments, $disabled })"
					>
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Appraisal status' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let gs; let gsIndex = index"
							[attr.data-label]="'Appraisal status'"
						>
							<ng-container *lowgileScope="gs; as: 'gs'; let $scope">
								<ng-container *lowgileScope="gsIndex; as: 'gsIndex'; let $scope">
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_69({ app, screen, $pathSegments, $disabled, gs, gsIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('status$id') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef>
							<div style="display: flex">
								<select
									#colFilterInput69
									[attr.data-filter-for-column]="'status$id'"
									style="flex-grow: 1"
								>
									<option value=""></option>
									<option
										*ngFor="let $option of Toolbox.GoalSettingStatus.getEntryList()"
										[value]="$option.id"
									>
										{{ $option.label }}
									</option>
								</select>
								<button
									[disabled]="!colFilterInput69.value"
									matSuffix
									mat-icon-button
									mat-small-icon-button
									aria-label="Clear"
									(click)="colFilterInput69.value = ''; $dispatchInputEvent(colFilterInput69)"
								>
									<mat-icon *ngIf="colFilterInput69.value">close</mat-icon>
								</button>
							</div>
						</th>
					</ng-container>
				</lowgile-table>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
